<template>
  <a-tabs>
    <a-tab-pane key="1" tab="基本信息">
      <a-descriptions :column='1'>
        <a-descriptions-item label="订单号">{{basicData.order_no}}</a-descriptions-item>
        <a-descriptions-item label="下单时间">{{basicData.order_time}}</a-descriptions-item>
        <a-descriptions-item label="签收时间">{{basicData.settle_time}}</a-descriptions-item>
        <a-descriptions-item label="商品信息">{{basicData.product_name}}</a-descriptions-item>
        <a-descriptions-item label="购买数量">{{basicData.buy_num}}</a-descriptions-item>
        <a-descriptions-item label="订单金额">{{basicData.total_price}}</a-descriptions-item>
        <a-descriptions-item label="积分/优惠券抵扣金额">{{basicData.discount_price}}</a-descriptions-item>
        <a-descriptions-item label="实际支付金额">{{basicData.pay_price}}</a-descriptions-item>
        <a-descriptions-item label="运费">{{basicData.freight_price}}</a-descriptions-item>
        <a-descriptions-item label="平台抽佣">{{basicData.platform_fees}}</a-descriptions-item>
        <a-descriptions-item label="分账总金额">{{basicData.split_price}}</a-descriptions-item>
      </a-descriptions>
    </a-tab-pane>
    <a-tab-pane key="2" tab="分账信息">
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='award_content' :columns='accountColumns' :data-source='basicData.split'>
        <template v-slot:name="{ record } ">
          {{record.role_name ? record.role_name : record.name}}
          <p v-if='record.role_name'>( {{record.name}} )</p>
        </template>
      </a-table>
    </a-tab-pane>
    <a-tab-pane key="3" tab="优惠金额积分转化">
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='award_content' :columns='discountColumns' :data-source='basicData.point'>
        <template v-slot:name="{ record } ">
          {{record.role_name}}
          <p>( {{record.name}} )</p>
        </template>
      </a-table>
    </a-tab-pane>
  </a-tabs>
</template>

<script>
  import { ref, onMounted, reactive, toRefs, inject } from 'vue';
  import { message } from 'ant-design-vue';
  import { getOrderInsteadShipMore } from "@/api/order";
  import { iscode } from "@/utils/app";
  export default {
    props: {
      id: String
    },
    setup(props) {
      const state = reactive({
        listLoading:true,
        basicData:{},
      })
      let accountColumns = [
        {
          title: "名称",
          dataIndex: "name",
          key: "name",
          slots: { customRender: "name" }
        },
        {
          title: "分账比例",
          dataIndex: "percent",
          key: "percent",
          customRender: ({ record }) => {
            return  record.percent+'%'
          }
        },
        {
          title: "分账金额",
          dataIndex: "money",
          key: "money",
        },
        {
          title: "手续费",
          dataIndex: "fess",
          key: "fess",
        },
        {
          title: "到账金额",
          dataIndex: "real_money",
          key: "real_money",
        }
      ];
      let discountColumns = [
        {
          title: "名称",
          dataIndex: "name",
          key: "name",
          slots: { customRender: "name" }
        },
        {
          title: "分账比例",
          dataIndex: "percent",
          key: "percent",
          customRender: ({ record }) => {
            return  record.percent+'%'
          }
        },
        {
          title: "积分",
          dataIndex: "role_point",
          key: "role_point",
        }
      ];
      const $route = inject('$route');
      const $router = inject('$router');
      const getMore = async() =>{
        const hide = message.loading('正在加载中...', 0);
        let res = await getOrderInsteadShipMore(props.id).then((res) => res.data);
        state.listLoading = false
        if (iscode(res)) {
          state.basicData = res.data
        }else{
          message.error(res.msg);
        }
        setTimeout(hide);
      }
      onMounted(() => {
        getMore();
      });
      return {
        ...toRefs(state),
        accountColumns,
        discountColumns
      }
    }
  }
</script>